import { render } from "./Typeahead.vue?vue&type=template&id=0496bf26&scoped=true"
import script from "./Typeahead.vue?vue&type=script&lang=js"
export * from "./Typeahead.vue?vue&type=script&lang=js"

import "./Typeahead.vue?vue&type=style&index=0&id=0496bf26&scoped=true&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0496bf26"]])

export default __exports__